import { client } from "../../../../Infrastructure/agent";

export const PemissionService = {
  getinitialData: () => client.get("/access/getinitialdata"),
  createOrUpdatePriviledge: (priviledge, action) => {
    const { copyfrom } = priviledge;
    const retval = client.post("/access/createorupdatepriviledge", {
      priviledge,
      action,
      copyfrom,
    });

    return retval;
  },

  getGroupPermissions: (groupId) =>
    client.post("/access/getgrouppermissions", { groupId }),
  removePriviledge: (priviledge) => {
    return client.post("/access/removeprivilege", {
      id: priviledge.groupId,
    });
  },

  addUserstoRole: (users, groupId) => {
    return client.post("/access/adduserstorole", { users, groupId });
  },
  updatePermission: (permission) => {
    return client.post("/access/updatepermission", { permission });
  },
  removeUserFromRole: (userId, roleId) => {
    return client.post("/access/removeuserfromrole", { userId, roleId });
  },
  getUserRoles: (userId) => {
    return client.post("/access/getuserroles", { userId });
  },
  getUserPermissions: (userId) => {
    return client.post("/access/getuserpermissions", { userId });
  },

  setUserPermisions: (permissions) => {
    return client.post("/access/setuserpermissions", { permissions });
  },
};

